import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { lookupRedirect } from '../../lib/redirects';
import { track } from '../../lib/analytics';

// Mounted once inside BrowserRouter. Checks every route change against the
// redirects map; on a hit, navigates with `replace: true` so the failed URL
// doesn't pollute the browser history. Fires an analytics event so we can
// see which redirects are actually used.

const Redirector = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hit = lookupRedirect(location.pathname);
    if (!hit) return;
    track('redirect_applied', {
      from_path: location.pathname,
      to_path: hit.to,
      status: hit.status,
    });
    navigate(`${hit.to}${location.search || ''}${location.hash || ''}`, { replace: true });
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
};

export default Redirector;
